import { Todo } from "./Todo";
import { useGetTodosQuery } from "../features/todo/api/todoApi";

export const Completed = () => {
    const { data, isLoading, isError } = useGetTodosQuery();

    let content;

    if (isLoading) content = <p className="text-green-600">Loading...</p>;

    if (!isLoading && isError)
        content = <p className="text-red-600">Network problem !</p>;

    if (!isLoading && !isError && data?.length > 0) {
        content = data.map((todo) => {
            if (todo.completed) {
                return <Todo key={todo.id} todo={todo} />;
            }
        });
    }

    const totalCompleted = data?.filter((todo) => {
        if (todo.completed) {
            return todo;
        }
    });

    return (
        <>
            <div className="mt-10 text-gray-700 text-sm max-h-[300px] overflow-y-auto">
                {/* <Todo /> */}
                <p className="p-3 bg-green-200 text-green-600 rounded">
                    Completed Tasks: {totalCompleted?.length}
                </p>
                {content}
            </div>
        </>
    );
};
